/** @format */

import {MultilineChartInterface} from 'components/charts/multiline-chart/model/common';

import {Chart} from 'components/charts/multiline-chart/model/charts';

import {ChartIds} from '../../models/chartIds';
import {WIDGETS_LIST} from '../../constants/widgets';
import {CHARTS_PREDICATES} from '../../constants/predicates';

import {getForecastZonePoints} from './getForecastZonePoints';
import {addForecastToSimpleChart} from './addForecastToSimpleChart';
import {addForecastToComplexChart} from './addForecastToComplexChart';
import {postProcessing} from './postProcessing';
import {ALL_CHART_IDS} from '../../constants/allChartIds';

/**
 * Точка входа для всех методов в этой папке.
 * Вычислит и добавит прогнозы для всех графиков (кроме cr).
 * @param data
 * @param rechartsDates
 */

const addForecast = (
  data: MultilineChartInterface<ChartIds>,
  rechartsDates: string[],
): MultilineChartInterface<ChartIds> => {
  // Сортируем графики на кучки:
  // 1. Без изменений
  // 2. Простые с прогнозом
  // 3. Составные с прогнозом
  const unchangedCharts: Chart<ChartIds>[] = [];

  const chartsWithForecast: Chart<ChartIds>[] = [];

  data.charts.forEach(chart => {
    const isForecast = WIDGETS_LIST[chart.chartId].addForecast;
    const isFunnel = !ALL_CHART_IDS.includes(chart.chartId);
    if (isForecast || isFunnel) {
      chartsWithForecast.push(chart);
    } else {
      unchangedCharts.push(chart);
    }
  });

  const simpleCharts: Chart<ChartIds>[] = [];
  const complexCharts: Chart<ChartIds>[] = [];

  chartsWithForecast.forEach(chart => {
    const isComplex = Boolean(CHARTS_PREDICATES[chart.chartId]?.forecastPredicate);
    if (isComplex) {
      complexCharts.push(chart);
    } else {
      simpleCharts.push(chart);
    }
  });

  // Подготавливаем списки ключей

  const {forecastPoints, normalPoints} = getForecastZonePoints(rechartsDates);

  // Обрабатываем обычные графики

  const simpleChartsWithForecast = simpleCharts.map(chart => {
    return addForecastToSimpleChart({
      chart,
      normalPoints,
      forecastPoints,
    });
  });

  // Обрабатываем составные графики

  const complexChartsWithForecast = complexCharts.map(chart => {
    return addForecastToComplexChart({
      chart,
      simpleChartsWithForecast,
      forecastDays: forecastPoints,
      normalPoints,
    });
  });

  // Постобработка готовых прогнозов

  const changedCharts = [...simpleChartsWithForecast, ...complexChartsWithForecast];
  const postProcessedCharts = postProcessing(changedCharts, normalPoints);

  return {
    ...data,
    charts: [...unchangedCharts, ...postProcessedCharts],
  };
};

export {addForecast};
